import { createTheme } from "@mui/material/styles";

/**
 * GfG MUI Theme — derived from GfG-Design-System-V1.0
 *
 * Setting fontFamily here is the correct way to make all MUI components
 * (Typography, Button, ListItemText, etc.) inherit Lato by default,
 * eliminating per-component fontFamily overrides.
 */
const gfgTheme = createTheme({
  typography: {
    fontFamily: "'Lato', sans-serif",

    h1: {
      fontFamily: "'Crimson Text', Georgia, serif",
      fontSize: "30px",
      fontWeight: 400,
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: "'Crimson Text', Georgia, serif",
      fontSize: "24px",
      fontWeight: 400,
      lineHeight: 1.2,
    },
    h3: {
      fontFamily: "'Crimson Text', Georgia, serif",
      fontSize: "22px",
      fontWeight: 400,
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: "'Crimson Text', Georgia, serif",
      fontSize: "20px",
      fontWeight: 400,
      lineHeight: 1.2,
    },
    subtitle1: {
      fontFamily: "'Lato', sans-serif",
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: 1.5,
    },
    body1: {
      fontFamily: "'Lato', sans-serif",
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: "'Lato', sans-serif",
      fontSize: "13px",
      fontWeight: 400,
      lineHeight: 1.5,
    },
    caption: {
      fontFamily: "'Lato', sans-serif",
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: 1.4,
    },
    overline: {
      fontFamily: "'Lato', sans-serif",
      fontSize: "11px",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "2px",
    },
  },

  palette: {
    primary: {
      main: "#AF9577", // Dark Dust
      light: "#C8B298", // Rodeo Dust
      dark: "#9B7D63", // hover
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "#333333", // Rodeo Black
      secondary: "#6D6D6D", // Graphite
    },
    divider: "#E0E0E0", // Smoke
    background: {
      default: "#FAFAFA",
      paper: "#FFFFFF",
    },
    error: {
      main: "#A34740", // Good Wine
      light: "#D4A4A1",
      contrastText: "#FFFFFF",
    },
    warning: {
      main: "#8A5D1F", // Good Ochre
      light: "#CFB591",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#637058", // Good Sage
      light: "#B5BBAF",
      contrastText: "#FFFFFF",
    },
    info: {
      main: "#2B4A60", // Good Night
      light: "#91A8B8",
      contrastText: "#FFFFFF",
    },
  },

  shape: {
    borderRadius: 6, // --radius-btn
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Lato', sans-serif",
          fontSize: "11px",
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "2px",
          borderRadius: "6px",
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
      },
    },
  },
});

export default gfgTheme;
